export interface IRosterListItem {
    id: string;
    jerseyNum: number;
    position: string | null | undefined;
    primaryPosition: string;
    firstName: string | undefined;
    lastName: string | undefined;
    laterality: string | null | undefined;
}

export enum RosterListSortProperty {
    POSITION = 'position',
    NUMBER = 'number',
    LAST_NAME = 'lastName'
}
